<template>
  <div class="elencocomponenti">
    <b-container fluid>
      <b-row class="headerbox">
        <b-col>
          <h5>Lista Componenti</h5>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col md="5">
          <b-form-group label-cols-sm="2" label="Cerca">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Cerca" />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"><font-awesome-icon icon="times-circle" /></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col>
          <b-button variant="success" v-if="stato.admin" style="float: right" to="/elenco/componenti/importa"><font-awesome-icon icon="file-import" /> Importa Componenti</b-button>
        </b-col>
        <b-col>
          <b-button variant="success" style="float: right" to="/elenco/componenti/aggiungi"><font-awesome-icon icon="plus-circle" /> Aggiungi Componente</b-button>
        </b-col>
      </b-row>
      <br>
      <b-row>
        <b-col>
          <b-table
            :striped="true"
            :hover="true"
            :responsive="true"
            :items="lista"
            :fields="campi"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template slot="action" slot-scope="row">
              <b-button v-if="row.item.idUser || stato.admin" size="sm" variant="danger" v-on:click="openModalDeleteComponente(row.item)"><font-awesome-icon icon="trash-alt" /></b-button>
              <b-button v-if="row.item.idUser || stato.admin" size="sm" style="margin-left: 10px;" :to="'/elenco/componenti/modifica/'+row.item.id"><font-awesome-icon icon="edit" /></b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            :total-rows="totalRows"
            :per-page="perPage"
            v-model="currentPage"
            align="center"
          />
        </b-col>
      </b-row>
    </b-container>

    <b-modal v-model="modal.delete" title="Conferma richiesta di eliminazione!">
      <p>Sei sicuro di voler eliminare <strong>{{modalData.delete.codcatalogo}}</strong>?</p>
      <div slot="modal-footer">
        <b-button class="float-right" variant="danger" style="margin-left: 10px" v-on:click="deleteComponente(modalData.delete.id)">Si</b-button>
        <b-button class="float-right" v-on:click="modal.delete = false">No</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  name: 'elencocomponenti',
  data() {
    return {
      lista: [],
      campi: [
        {key: 'codcatalogo', label: 'Codice Catalogo', sortable: true},
        {key: 'marca.nome', label: 'Marca', sortable: true},
        {key: 'tipocomponente.nome', label: 'Tipologia Componente', sortable: true},
        {key: 'sottotipocomponente.nome', label: 'Sottotipologia Componente', sortable: true},
        {key: 'action', label: '', sortable: false}
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      filter: null,
      modal: {
        delete: false
      },
      modalData: {
        delete: {}
      }
    }
  },
  created: function(){
    this.getListaComponenti()
  },
  methods: {
    getListaComponenti(){
      Vue.http.post('elenco/componenti', {}, {credentials : true}).then(response => {
        if(response.body.success){
            this.lista = response.body.list
            this.totalRows = this.lista.length
        }else{
          this.lista = []
            /*Vue.notify({
                group: 'global',
                title: 'Errore',
                text: "Lista Componenti non caricata correttamente.",
                type: 'error'
            })*/
        }
      }, response => {})
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    openModalDeleteComponente(item){
      this.modalData.delete = item
      this.modal.delete = true
    },
    deleteComponente(id){
      Vue.http.post('elenco/componenti/delete/'+id, {}, {credentials : true}).then(response => {
        if(response.body.success){
          this.getListaComponenti()
          
          this.modal.delete = false
          this.modalData.delete = {}

          Vue.notify({
              group: 'global',
              title: 'Operazione eseguita!',
              text: "Componente eliminato correttamente.",
              type: 'success'
          })
        }else{
          Vue.notify({
              group: 'global',
              title: 'Errore',
              text: response.body.msg,
              type: 'error'
          })
        }
      }, response => {})
    }
  },
  computed: {
    ...mapGetters(['stato'])
  }
}
</script>


<style>
</style>